import { Typography } from "antd";
import PropTypes from "prop-types";

import { TABLE_TITLE_COLUMN_TEXT } from "@/constants/Typography";

import { TableTitleCellLinkType } from "./TableTitleCell.type";
import LinkWrapper from "./TableTitleCellLinkWrapper";

const { Text } = Typography;

const TableTitleCell = ({ text, link, maxWidth }) => {
  if (!text) return null;

  return (
    <Text
      ellipsis={{ tooltip: text }}
      style={{ maxWidth: maxWidth ?? TABLE_TITLE_COLUMN_TEXT.MAX_WIDTH }}
    >
      <LinkWrapper link={link}>{text}</LinkWrapper>
    </Text>
  );
};

TableTitleCell.propTypes = {
  text: PropTypes.string,
  link: TableTitleCellLinkType,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TableTitleCell;
